/***
 * Created on 2025/6/27
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import {useTranslation} from "react-i18next";

function UserStatusComponent({user}) {
    const { t } = useTranslation();
    const get_status = () => {
        const status = user?.status;
        switch (status) {
            case 'active':
                return ['Activate', 'status-color-green'];
            case 'pending':
                return ['Invited', 'status-color-royal-blue'];
            case 'suspend':
                return ['Suspended', 'status-color-red'];
            // case '' || null || undefined:
            //     return ['QNAP ID not activated', 'status-color-purple'];
            default:
                return ['QID not activated', 'status-color-purple'];
        }
    }
    const [status, statusCss] = get_status();

    return (
        <div className={`status-tag ${statusCss} no-border !pl-0 !pr-0 disable-event`}>
            <span className="label">{`${t(`@${status}@`)}`}</span>
        </div>
    );
}

export default UserStatusComponent;